import type {
  ApiResponseBody,
  ApiSearchQuery,
} from '@/lib/api/api-type-helper';

// ---------------------------------------------------------------------------
// List API Types
// ---------------------------------------------------------------------------

export type GetReleaseTestDocumentListQuery = ApiSearchQuery<
  '/v2/qa-force/release-test-documents',
  'get'
>;
export type GetReleaseTestDocumentListResponse = ApiResponseBody<
  '/v2/qa-force/release-test-documents',
  'get'
>;
export type ReleaseTestDocumentListItem =
  GetReleaseTestDocumentListResponse['items'][0];

export type ReleaseTestDocumentOrderBy =
  NonNullable<GetReleaseTestDocumentListQuery>['orderBy'];

// ---------------------------------------------------------------------------
// Count API Types
// ---------------------------------------------------------------------------

export type GetReleaseTestDocumentCountQuery = ApiSearchQuery<
  '/v2/qa-force/release-test-documents/count',
  'get'
>;
export type GetReleaseTestDocumentCountResponse = ApiResponseBody<
  '/v2/qa-force/release-test-documents/count',
  'get'
>;

// ---------------------------------------------------------------------------
// Domain enums
// ---------------------------------------------------------------------------

export const ReleaseTestDocumentType = {
  FOR_INTERNAL: 'FOR_INTERNAL',
  FOR_EXTERNAL: 'FOR_EXTERNAL',
} as const;
export type ReleaseTestDocumentType =
  (typeof ReleaseTestDocumentType)[keyof typeof ReleaseTestDocumentType];

const RTD_TYPE_VALUES: ReadonlySet<string> = new Set(
  Object.values(ReleaseTestDocumentType),
);
export function isReleaseTestDocumentType(
  value: string | null | undefined,
): value is ReleaseTestDocumentType {
  return value != null && RTD_TYPE_VALUES.has(value);
}

/** 種別タブ用。ドメイン値 + "ALL"。 */
export type ReleaseTestDocumentTypeFilter = ReleaseTestDocumentType | 'ALL';

export const ReleaseTestDocumentStatus = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  IN_REVIEW: 'IN_REVIEW',
  DONE: 'DONE',
  ARCHIVED: 'ARCHIVED',
} as const;
export type ReleaseTestDocumentStatus =
  (typeof ReleaseTestDocumentStatus)[keyof typeof ReleaseTestDocumentStatus];

const RTD_STATUS_VALUES: ReadonlySet<string> = new Set(
  Object.values(ReleaseTestDocumentStatus),
);
export function isReleaseTestDocumentStatus(
  value: string | null | undefined,
): value is ReleaseTestDocumentStatus {
  return value != null && RTD_STATUS_VALUES.has(value);
}
